import { useEffect, useState } from "react";
import axios from "axios";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import VerificaToken from "../../../../components/utils/VerificaToken";
import "./AlterarSenha.css";

export default function AlterarSenha({
    aberto,
    onClose,
}) {
    const [email, setEmail] = useState("");

    const [senhaAntiga, setSenhaAntiga] =
        useState("");

    const [novaSenha, setNovaSenha] =
        useState("");

    const [mensagem, setMensagem] =
        useState("");

    const [tipo, setTipo] =
        useState("");

    const [loading, setLoading] =
        useState(false);

    const [mostrarSenhaAtual, setMostrarSenhaAtual] =
        useState(false);

    const [mostrarNovaSenha, setMostrarNovaSenha] =
        useState(false);

    const possuiMaiuscula = /[A-Z]/.test(novaSenha);
    const possuiMinuscula = /[a-z]/.test(novaSenha);
    const possuiNumero = /\d/.test(novaSenha);
    const possuiEspecial = /[^A-Za-z0-9]/.test(novaSenha);
    const tamanhoValido = novaSenha.length >= 6;

    const senhaValida =
        possuiMaiuscula &&
        possuiMinuscula &&
        possuiNumero &&
        possuiEspecial &&
        tamanhoValido;

    useEffect(() => {
        if (!aberto) return;

        async function carregar() {
            const usuario =
                await VerificaToken();

            setEmail(usuario.email);
        }

        carregar();

        setSenhaAntiga("");
        setNovaSenha("");
        setMensagem("");
        setTipo("");
    }, [aberto]);

    async function alterarSenha() {


        if (!senhaValida) {
            return;
        }
        try {
            setLoading(true);

            setMensagem("");

            const response =
                await axios.put(
                    "https://app.eliandroalimentos.com.br/api/primeiro_acesso/alterarsenha",
                    {
                        email,
                        senhaAntiga,
                        novaSenha,
                    }
                );

            setTipo("sucesso");

            setMensagem(
                response.data.message
            );

            setTimeout(() => {
                onClose();
            }, 1500);
        } catch (err) {
            setTipo("erro");

            if (
                err.response?.data?.error
            ) {
                setMensagem(
                    err.response.data.error
                );
            } else {
                setMensagem(
                    "Erro ao alterar senha."
                );
            }
        } finally {
            setLoading(false);
        }
    }

    if (!aberto) return null;

    return (
        <div
            className="alterar-overlay"
            onClick={onClose}
        >
            <div
                className="alterar-card"
                onClick={(e) =>
                    e.stopPropagation()
                }
            >
                <h2>Alterar Senha</h2>

                <div className="alterar-form">

                    <label>Senha Atual</label>

                    <div className="input-senha">

                        <input
                            type={
                                mostrarSenhaAtual
                                    ? "text"
                                    : "password"
                            }
                            value={senhaAntiga}
                            onChange={(e) =>
                                setSenhaAntiga(e.target.value)
                            }
                        />

                        <button
                            type="button"
                            className="btn-olho"
                            onClick={() =>
                                setMostrarSenhaAtual(
                                    !mostrarSenhaAtual
                                )
                            }
                        >
                            {mostrarSenhaAtual ? (
                                <FaEyeSlash />
                            ) : (
                                <FaEye />
                            )}
                        </button>

                    </div>

                    <label>Nova Senha</label>

                    <div className="input-senha">

                        <input
                            type={
                                mostrarNovaSenha
                                    ? "text"
                                    : "password"
                            }
                            value={novaSenha}
                            onChange={(e) =>
                                setNovaSenha(e.target.value)
                            }
                        />

                        <button
                            type="button"
                            className="btn-olho"
                            onClick={() =>
                                setMostrarNovaSenha(
                                    !mostrarNovaSenha
                                )
                            }
                        >
                            {mostrarNovaSenha ? (
                                <FaEyeSlash />
                            ) : (
                                <FaEye />
                            )}
                        </button>

                    </div>

                    <div className="senha-requisitos">

                        <div className={possuiMaiuscula && possuiMinuscula ? "ok" : ""}>
                            <span>
                                {possuiMaiuscula && possuiMinuscula ? "✔" : "○"}
                            </span>

                            Contém letra maiúscula e minúscula
                        </div>

                        <div className={possuiNumero ? "ok" : ""}>
                            <span>
                                {possuiNumero ? "✔" : "○"}
                            </span>

                            Contém um número
                        </div>

                        <div className={possuiEspecial ? "ok" : ""}>
                            <span>
                                {possuiEspecial ? "✔" : "○"}
                            </span>

                            Contém um caractere especial
                        </div>

                        <div className={tamanhoValido ? "ok" : ""}>
                            <span>
                                {tamanhoValido ? "✔" : "○"}
                            </span>

                            Mínimo de 6 caracteres
                        </div>

                    </div>

                    {mensagem && (
                        <div
                            className={`alterar-msg ${tipo}`}
                        >
                            {mensagem}
                        </div>
                    )}

                    <button
                        onClick={alterarSenha}
                        disabled={loading || !senhaValida}
                    >
                        {loading ? "Alterando..." : "Alterar"}
                    </button>

                </div>
            </div>
        </div>
    );
}